import { render, staticRenderFns } from "./CollectListComponent.vue?vue&type=template&id=5d838586&scoped=true"
import script from "./CollectListComponent.vue?vue&type=script&lang=js"
export * from "./CollectListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d838586",
  null
  
)

export default component.exports